/**
 * Function to check if a value is a array and isn't empty
 *
 * @param {*} a Any value
 * @returns {boolean} If `a` is a array and has more than one element returns TRUE otherwise FALSE
 */
export const arrayNotEmpty = (a) => {
    return Array.isArray(a) && a.length > 0;
};
